import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/services/api'
import { SystemConfig } from '@/types'
import { toast } from 'sonner'

const CONFIG_QUERY_KEY = 'config'

export const useSystemConfig = () => {
  return useQuery<SystemConfig[]>({
    queryKey: [CONFIG_QUERY_KEY],
    queryFn: async () => {
      const { data } = await api.get('/config')
      return data
    },
  })
}

export const useUpdateConfig = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      key,
      value,
    }: {
      key: string
      value: string | number | boolean | Record<string, unknown> | unknown[]
    }) => {
      const { data } = await api.patch(`/config/${key}`, { value })
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CONFIG_QUERY_KEY] })
      toast.success('Configuración actualizada')
    },
  })
}
